import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserNotification} from "../user-notification";

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent implements OnInit {

  @Input() notification: UserNotification;

  @Output() markAsRead: EventEmitter<boolean> = new EventEmitter();

  @Output() clickActionEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  markAsReadAction() {
    this.markAsRead.emit(true);
  }

  clickAction() {
    this.clickActionEmitter.emit(true);
    this.markAsReadAction();
  }
}
